import CRUDService from "./base/CRUDService";

export default class CompanyService extends CRUDService {

  static ALL_URL = 'auth/v1/companies/'

  getBaseURL() {
    return CompanyService.ALL_URL;
  }

}



// WEBPACK FOOTER //
// ./src/services/CompanyService.js